import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { GiftIcon } from 'lucide-react';
import { useCurrency } from '../hooks/useCurrency';
export function CTASection() {
  const {
    originalPrice,
    salePrice,
    code,
    loading
  } = useCurrency();
  return <Section id="cta" className="bg-navy-900 pb-32" dark={true} data-id="element-16">
      <div className="max-w-4xl mx-auto bg-gradient-to-b from-navy-800 to-navy-900 rounded-3xl p-8 md:p-16 text-center border border-navy-700 shadow-2xl relative overflow-hidden" data-id="element-17">
        {/* Glow effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-lg bg-gold-500/5 blur-3xl rounded-full pointer-events-none" data-id="element-18" />

        <div className="relative z-10 space-y-8" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-serif text-cream-50" data-id="element-20">
            Obtén el libro digital hoy
          </h2>

          <div className="space-y-2" data-id="element-21">
            <h3 className="md:text-3xl font-serif text-gold-400 text-[32px]" data-id="element-22">
              El Libro Digital Sueño y Serenidad
            </h3>
            <p className="text-lg text-cream-100/60 uppercase tracking-widest" data-id="element-23">
              Para Mujeres de 40+
            </p>
          </div>

          <div className="py-4" data-id="element-24">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-25">
              <span className="text-2xl md:text-3xl font-serif text-cream-100/40 line-through" data-id="element-26">
                {loading ? <span className="inline-block w-16 h-7 bg-navy-700/60 rounded animate-pulse" data-id="element-27" /> : originalPrice}
              </span>
              <span className="bg-gold-500 text-navy-900 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-28">
                60% DE DESCUENTO
              </span>
            </div>
            <div className="text-5xl md:text-6xl font-serif text-cream-50 font-bold min-h-[1.2em] flex items-center justify-center" data-id="element-29">
              {loading ? <span className="inline-block w-36 h-14 bg-navy-700/60 rounded-lg animate-pulse" data-id="element-30" /> : <span data-id="element-31">
                  {salePrice}
                  {code !== 'USD' && <span className="ml-3 text-xl md:text-2xl text-cream-100/40 font-normal align-middle" data-id="element-32">
                      {code}
                    </span>}
                </span>}
            </div>
          </div>

          {/* Bonos Section */}
          <div className="py-6 border-y border-navy-700/50 space-y-6" data-id="element-33">
            <div className="flex items-center justify-center gap-3" data-id="element-34">
              <GiftIcon className="w-6 h-6 text-gold-400" data-id="element-35" />
              <h4 className="text-xl md:text-2xl font-serif text-gold-400 uppercase tracking-wide font-[700]" data-id="element-36">
                + Bono Incluido
              </h4>
              <GiftIcon className="w-6 h-6 text-gold-400" data-id="element-37" />
            </div>

            <div className="max-w-lg mx-auto space-y-5" data-id="element-38">
              <div className="relative" data-id="element-39">
                <p className="text-center text-lg md:text-xl font-serif font-bold uppercase tracking-widest mb-4 drop-shadow-lg text-[#40e13d]" data-id="element-40">
                  Esto Cambiará Tu Vida Para Siempre
                </p>
                <img src="https://cdn.magicpatterns.com/uploads/gKd31Pxkc8df7K4B3ADVSh/heylloyd-image-1771271609869.png" alt="Meditaciones Espirituales de Dios - Audio y Libro Digital" className="w-full max-w-md mx-auto rounded-2xl shadow-lg shadow-navy-900/50" data-id="element-41" />
              </div>

              <h5 className="text-xl md:text-2xl font-serif text-cream-50" data-id="element-42">
                Meditaciones Espirituales Transformadoras
              </h5>
              <p className="text-gold-400 uppercase tracking-widest text-[20px] font-[900]" data-id="element-43">
                Audio y Libro Digital
              </p>
              <p className="text-base text-cream-100/70 leading-relaxed max-w-md mx-auto" data-id="element-44">
                Meditaciones Espirituales Transformadoras para calmar tu mente,
                encontrar paz interior y descansar en la Presencia de Dios.
                Perfectas para la mañana, la tarde o antes de dormir.
              </p>

              <div className="grid grid-cols-3 gap-3 max-w-xs mx-auto" data-id="element-45">
                {['Paz', 'Dominio propio', 'Sueño'].map(tag => <span key={tag} className="text-xs text-gold-400 border border-gold-500/30 rounded-full px-3 py-1.5 bg-gold-500/5" data-id="element-46">
                    {tag}
                  </span>)}
              </div>
            </div>
          </div>

          <div className="max-w-md mx-auto" data-id="element-47">
            <ul className="text-left space-y-3 mb-6" data-id="element-48">
              <li className="flex items-start gap-3" data-id="element-49">
                <span className="text-gold-400 text-lg leading-6" data-id="element-50">✓</span>
                <span className="text-cream-100/80 text-base" data-id="element-51">
                  Libro Digital "Sueño y Serenidad" — tu guía completa para
                  dormir mejor
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-52">
                <span className="text-gold-400 text-lg leading-6" data-id="element-53">✓</span>
                <span className="text-cream-100/80 text-base" data-id="element-54">
                  Bono: Meditaciones Espirituales Transformadoras (Audio + Libro
                  Digital)
                </span>
              </li>
            </ul>
            <Button href="https://www.mellowreset.com/cart/42935503323202:1" trackCheckout={true} fullWidth className="text-xl py-6 shadow-gold-500/20 shadow-xl" data-id="element-55">
              Obtener El Libro Digital Ahora
            </Button>
            <p className="mt-6 text-sm text-cream-100/50" data-id="element-56">
              Pago seguro • Descarga digital instantánea
            </p>
          </div>

          <p className="text-lg text-cream-100/80 pt-8 border-t border-navy-700/50 max-w-lg mx-auto" data-id="element-57">
            No necesitas una noche perfecta. <br data-id="element-58" />
            Necesitas un cierre repetible para tu día.
          </p>
        </div>
      </div>
    </Section>;
}